import React from 'react';
import configs from '../../../redux/chart-iq/chart/config';
import { ChartResponsiveSize } from '../Chart';
import { MenuSelect } from './';

interface IComparisonProps {
  addComparisonAndSave: (ciq: any, symbolCompare: string, seriesParams: any) => void,
  ciq: any,
  comparisons: any[],
  responsiveSize: string,
	symbol: string,
}

interface IComparisonState {
	text: string
}

export class Comparison extends React.Component<IComparisonProps, IComparisonState> {
	constructor(props: IComparisonProps) {
		super(props);
		this.state = {
			text: '',
		};
		this.bindCorrectContext();
	}

	public onOptionClick() {
		function getRandomColor() {
			const letters = '0123456789ABCDEF';
			let color = '#';
			for (let i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		}

		const seriesParams = {
			color: getRandomColor(),
			data: {
				useDefaultQuoteFeed: true,
			},
			isComparison: true,
		};

    const symbolCompare = this.state.text.replace(/\s/g, '').toUpperCase();
    if (symbolCompare && !this.props.comparisons.find(comp => comp && comp.id === symbolCompare) && symbolCompare !== this.props.symbol) {
      this.props.addComparisonAndSave(this.props.ciq, symbolCompare, seriesParams);
    }

		this.setState({
			text: '',
		});
  }

	public getPlaceholderText() {
		switch (this.props.responsiveSize) {
			case (ChartResponsiveSize.MEDIUM):
				return 'Compare';
			case (ChartResponsiveSize.SMALL):
				return 'cf.';
			default:
				return 'Add Comparison';
		}
	}

	public removeComparison(params: any, param2: any) {
		// if (this.props.comparisons) {
		// 	this.props.ciq.removeSeries(this.props.comparisons.id);
		// }
		this.setState({
			text: param2.id,
		}, this.onOptionClick);
		// this.onOptionClick();
		// console.log(`param: ${JSON.string(params)}\nparam2: ${JSON.stringify(param2)}`);
		// this.props.ciq.addSeries(param2.id);
		// this.props.ciq.removeSeries(param2.id);
	}

	public bindCorrectContext() {
		this.onOptionClick = this.onOptionClick.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.removeComparison = this.removeComparison.bind(this);
	}

	public handleKeyPress(event: React.KeyboardEvent) {
		const key = event.key;
		if (key === 'Enter') {
			this.onOptionClick();
		}
	}

	public render() {
		return (
			<React.Fragment>
					<MenuSelect
						hasCheckboxes={true}
						selected={this.props.comparisons}
						options={configs.symbols.filter(sym => this.props.symbol !== sym.id)}
						keyName="id"
						name="label"
						handleOptionSelect={this.removeComparison}
						needsCiq={true}
						ciq={this.props.ciq}
						menuId="stuff"
						title="Comparison" />
			</React.Fragment>
		);
	}
}